<template>
  <div class="column is-2">
    <div class="box">
      <p>{{ message.date }}</p>
      <p>{{ message.name }}</p>
      <p class="has-text-weight-bold">{{ message.message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "message",
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
};
</script>